<template>
  <div class="router-header flex flex-wrap items-center">
    <div class="content-area__heading">
      <p class="font">Tracking</p>
    </div>
    <div class="ml-auto md:block">
      <vs-button
        color="success"
        icon="icon-search"
        @click="data_hide = !data_hide"
        icon-pack="feather"
        >Search</vs-button
      >
    </div>
    <vx-card class="mt-4" v-show="data_hide">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-full">
          <label>{{ $t("labels.search_by_phone") }}</label>
          <vs-input
            class="w-full mt-0"
            icon-pack="feather"
            v-model="search"
            @keyup.enter="getAllTracking()"
            icon="icon-user"
            :placeholder="$t('labels.search_by_phone')"
            icon-no-border
          />
        </div>

        <div class="vx-col md:w-1/4 w-full">
          <label>{{ $t("labels.last_Date") }}</label>
          <flat-pickr
            class="w-full mt-0 mb-2"
            :config="configFromdateTimePicker"
            v-model="fromDate"
            :placeholder="$t('labels.last_Date')"
            @on-change="onFromChange"
          />
        </div>
        <!-- <div class="vx-col md:w-1/5 w-full">
            <label>{{$t('labels.end_Date')}}</label>
            <flat-pickr
              class="w-full mt-0 mb-2"
              :config="configTodateTimePicker"
              v-model="toDate"
              :placeholder="$t('labels.endDate')"
              @on-change="onToChange"
            />
          </div> -->
        <div class="vx-col md:w-1/4 w-full">
          <label>{{ $t("labels.device_type") }}</label>
          <v-select
            label="text"
            :clearable="false"
            :label-placeholder="$t('labels.selectEmail')"
            v-model="device_type"
            :options="devices"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
        </div>
        <div class="vx-col md:w-1/2 w-full pt-6 con_inquiry">
          <vs-button
            class="
              vs-component vs-button
              px-4
              w-full
              md:w-auto
              mb-1
              md:mt-0 md:mb-0
              vs-button-primary vs-button-filled
            "
            color="success"
            type="filled"
            @click.stop="getAllDeviceInfo()"
            >{{ $t("labels.search") }}</vs-button
          >
          <vs-button
            class="
              ml-2
              vs-component vs-button
              px-4
              w-full
              md:w-auto
              mb-1
              md:mt-0 md:mb-0
              vs-button-primary vs-button-filled
            "
            color="danger"
            type="filled"
            @click.stop="ResetFilter()"
            >{{ $t("labels.reset") }}</vs-button
          >

          <vs-button
            class="
              vs-component
              ml-2
              vs-button
              px-4
              w-full
              md:w-auto
              mb-1
              md:mt-0 md:mb-0
            "
            color="dark"
            type="filled"
            @click.stop="FilterOpen()"
            >{{ $t("labels.close") }}</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card class="mt-4">
      <div class="user-table">
        <vs-table max-items="10" :data="users">
          <template slot="thead">
            <vs-th>{{ $t("labels.device_id") }}</vs-th>
            <vs-th>{{ $t("labels.device_name") }}</vs-th>
            <vs-th>{{ $t("labels.model_number") }}</vs-th>
            <vs-th>{{ $t("labels.os_version") }}</vs-th>
            <vs-th>{{ $t("labels.app_version") }}</vs-th>
            <vs-th>{{ $t("labels.device_type") }}</vs-th>
            <vs-th>{{ $t("labels.first_opened") }}</vs-th>
            <vs-th>{{ $t("labels.last_opened") }}</vs-th>
            <vs-th>{{ $t("labels.email") }}</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr
              :data="tr"
              :key="indextr"
              v-for="(tr, indextr) in data"
              style="cursor: auto !important"
            >
              <vs-td>{{ tr.device_id }}</vs-td>
              <vs-td>{{ tr.device_name }}</vs-td>
              <vs-td>{{ tr.model_number }}</vs-td>
              <vs-td>{{ tr.os_version }}</vs-td>
              <vs-td>{{ tr.app_version }}</vs-td>
              <vs-td>
                <div v-if="tr.user_detail">
                  <p class="approveda" v-if="tr.user_detail.device_type == 'A'">
                    {{ $t("labels.android") }}
                  </p>
                  <p class="rejecteda" v-if="tr.user_detail.device_type == 'I'">
                    {{ $t("labels.Ios") }}
                  </p>
                </div>
                <p v-if="!tr.user_detail">--</p>
              </vs-td>
              <vs-td>
                <p v-if="tr.user_detail.created_at">
                  {{ tr.user_detail.created_at | formatDateTime }}
                </p>
                <p v-if="!tr.user_detail.created_at">--</p>
              </vs-td>
              <vs-td>
                <p v-if="tr.user_detail.last_login_at">
                  {{ tr.user_detail.last_login_at | formatDateTime }}
                </p>
                <p v-if="!tr.user_detail.last_login_at">--</p>
              </vs-td>
              <vs-td>
                <div v-if="tr.user_detail">
                  <p v-if="tr.user_detail.email">{{ tr.user_detail.email }}</p>
                  <p v-if="!tr.user_detail.email">--</p>
                </div>
                <p v-if="!tr.user_detail">--</p>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>
    <div style="height: 50px">
      <div class="float-left mt-5">
        <vs-pagination
          ref="paginationContact"
          :total="totalPage"
          v-model="currentPage"
        ></vs-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
export default {
  components: {
    flatPickr,
    "v-select": vSelect,
  },
  data() {
    return {
      data_hide: false,
      search: null,
      reject_reason: "",
      page: 1,
      perPage: 10,
      totalPage: 0,
      currentPage: 1,
      users: [],
      fromDate: null,
      toDate: null,
      date: null,
      format: "d MMM yyyy",
      email: "",
      configFromdateTimePicker: {
        // minDate: new Date(),
        // maxDate: null,
        dateFormat: "d/m/y",
      },
      configTodateTimePicker: {
        minDate: null,
        dateFormat: "d/m/y",
      },
      device_type: {
        text: "All",
        value: null,
      },
      devices: [
        {
          text: "All",
          value: null,
        },

        {
          text: "Android",
          value: "A",
        },
        {
          text: "iOS",
          value: "I",
        },
      ],
    };
  },
  methods: {
    FilterOpen() {
      this.data_hide = !this.data_hide;
    },
    ResetFilter() {
      this.fromDate = "";
      this.search = "";
      this.device_type = {
        text: "All",
        value: null,
      };
      this.getAllDeviceInfo();
    },
    getAllDeviceInfo() {
      let input = {
        page: 1,
        perPage: 10,
        search: this.search,
        device_type: this.device_type.value,
        date: this.fromDate,
      };
      axios
        .post("tracking/getDeviceInfo", input)
        .then((response) => {
          let data = response.data.data;
          this.users = data.users;
          this.totalPage = Math.ceil(data.count / this.perPage);
          let page = this.$route.query.page;
          if (page) {
            this.currentPage = page;
          }
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    onFromChange(selectedDates, dateStr, instance) {
      this.$set(this.configTodateTimePicker, "minDate", dateStr);
    },
  },
  mounted() {
    this.getAllDeviceInfo();
  },
};
</script>

<style lang="scss" scoped>
</style>